import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowTriangleRight"><Path d="M4 3.53711V20.4642L20.927 12.0006L4 3.53711Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleRight;
